import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import Report from './OrderSummaryReport';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';


const ReportIndex = () => {
    useEffect(() => {
        generateOrderSummaryReport();
    }, [])

    const [loading, setLoading] = useState(false);
    const [isNoRecordFound, setNoRecordFound] = useState(false);
    const [isReport, setReports] = useState(null);


    const generateOrderSummaryReport = async () => {
        try {
            setLoading(true);
            const response = await PndRestApi.GenerateOrderSummaryReport();
            if (response.status === 200 && response.data.status === 200) {
                setReports(response.data.data);
            } else if (response?.data?.status && response?.data?.status === 204) {
                setNoRecordFound(true);
            } else {
                showNotification(
                    "theme-light",
                    "ltr",
                    `SuccessCode: ${response.data.status}`,
                    `Message:${response.data.message}`,
                );
                return;
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            showNotification(
                "theme-light",
                "ltr",
                `SuccessCode: 500`,
                ERROR_MESSAGES.tryCatchError,
            );
        } finally {
            setLoading(false);
        }
    };


    return (
        <Container>

            {loading && <LinearProgress color="primary" />} {/* Display progress bar while loading */}
            {isReport && isReport != null && <Report isReport={isReport} />}
            {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}

        </Container>
    );
};

export default ReportIndex;